import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';

import Container from 'partials/Container';
import { gtmPush, refreshExpirationDate } from 'helpers';

import { cookie } from 'helpers';

import {
    setCheckoutVisibility,
    setChatVerticalPadding,
    resetChat,
    setCheckoutStep
} from 'store';

const CartBar = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 25px 0;
    color: #FFFFFF;
    background: ${css.colors.blue};
`;

const Description = styled.div`
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    .text {
        margin: 15px;

        b {
            font-weight: bold;
        }
    }

    .icon {
        display: table;
        width: 36px;
        height: 36px;
        background-color: white;
        border-radius: 50%;

        .value {
            text-align: center;
            top: 7px;
            color: #000000;
        }
    }
`;

const Button = styled.button`
    background-color #FFFFFF;
    color: ${css.colors.blue};
    padding: 10px 20px;
    border-radius: 50px;
    cursor: pointer;

    .icon {
        position: relative;
        margin-left: 10px;
        bottom: 1px;
    }
`;

class DesktopCart extends Component {
    constructor() {
        super();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.opportunity.courses != this.props.opportunity.courses) {
            if (prevProps.opportunity.courses.length > 0) {
                this.props.setCheckoutStep(0);
                cookie.set('shoppingCartTimeScheduleAutumn', '', 1);
                cookie.set('shoppingCartTimeScheduleSpring', '', 1);
            }
        }
        if (!this._showCart()) {
            this.props.resetChat();
        }
        this.props.setChatVerticalPadding(120);
    }

    _openCheckout() {
        if (refreshExpirationDate()) {
            return;
        }

        this.props.setCheckoutVisibility(true);

        this.props.resetChat();

        gtmPush({
            'event': 'GAEvent',
            'eventCategory': 'checkout',
            'eventAction': 'open',
            'eventLabel': 'Open Checkout',
            'eventValue': 20,
            'nonInteraction': false
        });
    }

    _showCart() {
        const { courses, programs } = this.props.opportunity;

        return courses.length + programs.length > 0;
    }

    _calculateTotal(products) {
        let total = 0;

        products.forEach(product => {
            total += product.price;
        });

        return total;
    }

    render() {
        const { courses, programs } = this.props.opportunity;

        return !this._showCart() ? (
            null
        ) : (
            <CartBar>
                <Container flex align="center" justify="space-between">
                    <Description onClick={this._openCheckout.bind(this)}>
                        <div className="icon">
                            <div className="value"> {courses.length + programs.length} </div>
                        </div>
                        <div className="text">
                            Du har <b>{courses.length + programs.length}</b>  i listen din, til totalt <b>{parseInt(this._calculateTotal([...courses, ...programs])).toLocaleString('de-DE')},-</b>
                        </div>
                    </Description>
                    <Button onClick={this._openCheckout.bind(this)}>
                        Gå videre <span className="icon"> &rarr; </span>
                    </Button>
                </Container>
            </CartBar>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
});

const actions = {
    setCheckoutVisibility,
    setChatVerticalPadding,
    resetChat,
    setCheckoutStep
}

export default connect(mapStateToProps, actions)(DesktopCart);



// WEBPACK FOOTER //
// ./src/partials/shared/Cart/DesktopCart.js